import React from 'react'
import { InlineMutation } from 'components/inlineMutation'
import './styles.scss'

export const VariantsTable = () => {
  const variants = [
    {
      name: 'Delta',
      code: '21A',
      mutations: [
        { protein: 'S', from: 'T', to: 'R', pos: 19 },
        { protein: 'S', from: 'L', to: 'R', pos: 452 },
        { protein: 'S', from: 'T', to: 'K', pos: 478 },
        { protein: 'S', from: 'D', to: 'G', pos: 614 },
        { protein: 'S', from: 'P', to: 'R', pos: 681 },
        { protein: 'S', from: 'D', to: 'N', pos: 950 },
        { protein: 'S', from: 'E', to: '-', pos: 156 },
        { protein: 'S', from: 'F', to: '-', pos: 157 },
        { protein: 'S', from: 'R', to: 'G', pos: 158 }
      ]
    },
    {
      name: 'Omicron',
      code: '21K',
      mutations: [
        { protein: 'S', from: 'A', to: 'V', pos: 67 },
        { protein: 'S', from: 'H', to: '-', pos: 69 },
        { protein: 'S', from: 'V', to: '-', pos: 70 },
        { protein: 'S', from: 'T', to: 'I', pos: 95 },
        { protein: 'S', from: 'G', to: '-', pos: 142 },
        { protein: 'S', from: 'Y', to: '-', pos: 144 },
        { protein: 'S', from: 'Y', to: 'D', pos: 145 },
        { protein: 'S', from: 'G', to: 'D', pos: 339 },
        { protein: 'S', from: 'S', to: 'L', pos: 371 },
        { protein: 'S', from: 'S', to: 'P', pos: 373 },
        { protein: 'S', from: 'S', to: 'F', pos: 375 },
        { protein: 'S', from: 'K', to: 'N', pos: 417 },
        { protein: 'S', from: 'N', to: 'K', pos: 440 },
        { protein: 'S', from: 'S', to: 'N', pos: 477 },
        { protein: 'S', from: 'T', to: 'K', pos: 478 },
        { protein: 'S', from: 'E', to: 'A', pos: 484 },
        { protein: 'S', from: 'Q', to: 'R', pos: 493 },
        { protein: 'S', from: 'Q', to: 'R', pos: 498 },
        { protein: 'S', from: 'N', to: 'Y', pos: 501 },
        { protein: 'S', from: 'Y', to: 'H', pos: 505 },
        { protein: 'S', from: 'D', to: 'G', pos: 614 },
        { protein: 'S', from: 'H', to: 'Y', pos: 655 },
        { protein: 'S', from: 'N', to: 'K', pos: 679 },
        { protein: 'S', from: 'P', to: 'H', pos: 681 },
        { protein: 'S', from: 'N', to: 'K', pos: 764 },
        { protein: 'S', from: 'D', to: 'Y', pos: 796 },
        { protein: 'S', from: 'Q', to: 'H', pos: 954 },
        { protein: 'S', from: 'N', to: 'K', pos: 969 },
        { protein: 'S', from: 'V', to: '-', pos: 143 },
        { protein: 'S', from: 'N', to: '-', pos: 211 },
        { protein: 'S', from: 'L', to: 'I', pos: 212 },
        { protein: 'S', from: 'G', to: 'S', pos: 446 },
        { protein: 'S', from: 'G', to: 'S', pos: 496 },
        { protein: 'S', from: 'T', to: 'K', pos: 547 },
        { protein: 'S', from: 'N', to: 'K', pos: 856 },
        { protein: 'S', from: 'L', to: 'F', pos: 981 }
      ]
    }
  ]

  return (
    <div>
      <div>
        {variants.map(variant => (
          <div
            className='mutations-list-container'
            key={`variant-${variant.name}`}
          >
            <div className='mutations-list-title'>
              <b>{variant.code}</b> ({variant.name})
              <div className='mutations-list-subtitle'>
                {variant.mutations.length} mutations
              </div>
            </div>
            <div className='mutations-list'>
              {variant.mutations.map((mutation: Mutation) => (
                <div
                  className='mutation'
                  key={`mutation-${mutation.protein}-${mutation.from}-${mutation.to}-${mutation.pos}`}
                >
                  <InlineMutation
                    protein={mutation.protein}
                    from={mutation.from}
                    to={mutation.to}
                    pos={String(mutation.pos).padStart(3, '0')}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
